import axios from 'axios';
import baseService from '../shared/baseService';

const clipperService = () => baseService('clippers');
const getClipperByFilters = (name: string, clientId?: number, includeInactive?:boolean) =>{
    let query = '';

    if (name && name != '')
        query = `?name=${name}`;

    if (clientId && clientId > 0) {
        if (query == '')
            query = `?clientId=${clientId}`;
        else 
            query += `&clientId=${clientId}`;
    }

    if (includeInactive != null) {
        if (query == '')
            query = `?includeInactive=${includeInactive}`;
        else 
            query += `&includeInactive=${includeInactive}`;
    }
        
    return axios.get(`clippers/filters${query}`);
};

export default {
    clipperService,
    getClipperByFilters,
};